import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IComponentOptions, ITimeoutService, IController, IOnChangesObject, IChangesObject, IPromise } from "angular";

import { IIndicator, IUIError } from "../models";
import { createUIError, logCaughtJsError } from "../util";
import { IAppConfig } from "@gtmhub/env";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";

interface IndicatorComponentBindings {
  value?: IIndicator;
  message?: string;
  inline?: boolean;
  noSpinner?: boolean;
  noSluggish?: boolean;
  noBody?: boolean;
  reset?(): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IndicatorComponentCtrl extends IndicatorComponentBindings {}
export class IndicatorComponentCtrl implements IController {
  longLastingRequest?: boolean;
  timingOut?: boolean;
  uiError?: IUIError;

  private sluggishTimeout: IPromise<void>;

  static $inject = ["$timeout", "appConfig", "UIErrorHandlingService", "$rootScope"];

  constructor(
    private $timeout: ITimeoutService,
    private appConfig: IAppConfig,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $rootScope: ITraceRootScopeService
  ) {}

  $onChanges(onChangesObj: IOnChangesObject): void {
    const value = onChangesObj.value as IChangesObject<IIndicator>;
    if (value) {
      this.cancelSluggishTimeout();

      if (value.currentValue) {
        if ("progress" in value.currentValue) {
          if (value.currentValue.progress) {
            this.setSluggishTimeout();
          }

          this.uiError = null;
        } else {
          logCaughtJsError(value.currentValue.error, this.appConfig);
          this.uiError = createUIError(value.currentValue.error);
          this.uiErrorHandlingService.trackError("indicator");
        }
      }
    }
  }

  resetError(): void {
    this.$rootScope.traceAction("reset_indicator_error", () => {
      if ("reset" in this.value) {
        this.value.reset();
      }

      this.reset && this.reset();

      delete this.value;
    });
  }

  private setSluggishTimeout() {
    this.sluggishTimeout = this.$timeout(() => {
      this.longLastingRequest = true;

      this.sluggishTimeout = this.$timeout(() => {
        this.longLastingRequest = false;
        this.timingOut = true;
        this.sluggishTimeout = null;
      }, 75000);
    }, 5000);
  }

  private cancelSluggishTimeout() {
    if (this.sluggishTimeout) {
      this.$timeout.cancel(this.sluggishTimeout);
      this.sluggishTimeout = null;
    }

    this.longLastingRequest = false;
    this.timingOut = false;
  }
}

export const IndicatorComponent: IComponentOptions = {
  controller: IndicatorComponentCtrl,
  templateUrl: require("./indicator.jade"),
  bindings: {
    value: "<",
    message: "@",
    inline: "<",
    noSpinner: "<",
    noSluggish: "<",
    noBody: "<",
    reset: "&",
  },
};
